var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    viewBox: "0 0 622 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.4 329.76C179.701 295.433 193.549 262.614 217.928 238.447C242.308 214.28 275.247 200.721 309.575 200.721C343.904 200.721 376.843 214.28 401.222 238.447C425.602 262.614 439.45 295.433 439.75 329.76",
    fill: "#FAE8B6"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_502_484",
    maskUnits: "userSpaceOnUse",
    x: 423.07,
    y: 0.599609,
    width: 152,
    height: 218,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 423.07,
    y: 0.599609,
    width: 152,
    height: 218
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.07 218.6V1.59961H574.07V218.6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424.07 218.6V1.59961H574.07V218.6",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.07 1.59961V0.599609H423.07V1.59961H424.07ZM574.07 1.59961H575.07V0.599609H574.07V1.59961ZM425.07 218.6V1.59961H423.07V218.6H425.07ZM424.07 2.59961H574.07V0.599609H424.07V2.59961ZM573.07 1.59961V218.6H575.07V1.59961H573.07Z",
    fill: "black",
    mask: "url(#path-2-outside-1_502_484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.07 1.5V218.5H450.69V1.5H424.07Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 23.9797V17.2998H460.76V23.9797H564Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 80.9702V74.29H460.76V80.9702H564Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.69 1.5V218.5",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.771 58.4795H564.01V17.2695H460.771V58.4795Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.771 115.45H564.01V74.25H460.771V115.45Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.99 131.35H460.75V172.52H563.99V131.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 138.03V131.34H460.75V138.03H564Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 195.04V188.36H460.75V195.04",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.76 172.51H564V131.31H460.76V172.51Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 218.6V188.37H460.75V218.6",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7 224.6C125.698 228.643 127.24 232.535 130.011 235.479C132.783 238.423 136.574 240.198 140.61 240.44L483.04 260.88C484.956 260.994 486.874 260.716 488.678 260.061C490.482 259.407 492.133 258.391 493.53 257.075C494.926 255.759 496.039 254.171 496.799 252.409C497.559 250.647 497.951 248.748 497.95 246.83V246.83",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.92 329.76L319.25 174.951C317.67 163.711 301.44 163.711 299.87 174.951L278.2 329.76H340.92Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.05 329.77H454.11",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.58 261.7C315.197 261.7 319.75 257.147 319.75 251.53C319.75 245.914 315.197 241.36 309.58 241.36C303.963 241.36 299.41 245.914 299.41 251.53C299.41 257.147 303.963 261.7 309.58 261.7Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7305 196.8V143.23H108.96L118.15 135.74V196.8H57.7305Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.39 196.79H2.15039C40.0072 215.349 81.6093 224.998 123.771 224.998C165.932 224.998 207.534 215.349 245.39 196.79V196.79Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.15 196.8V135.74",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.82 140.47V196.8",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7305 196.8V143.23",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.56 101.4H153.98L197.17 141.74V143.45H189.82V140.47L153.98 106.78L108.96 143.45H48.54V138.07L93.56 101.4Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M197.64 141.74C197.64 141.676 197.626 141.613 197.6 141.554C197.575 141.496 197.537 141.443 197.49 141.4L154.3 101.05C154.214 100.979 154.107 100.94 153.995 100.94C153.884 100.94 153.776 100.979 153.69 101.05L108.791 137.62H48.5405C48.4159 137.62 48.2961 137.669 48.208 137.758C48.1199 137.846 48.0703 137.965 48.0703 138.09V143.46C48.0703 143.585 48.1199 143.704 48.208 143.792C48.2961 143.88 48.4159 143.93 48.5405 143.93H108.92C108.977 143.939 109.034 143.939 109.09 143.93H109.14H109.21L153.92 107.52L189.31 140.8V143.57C189.31 143.694 189.36 143.814 189.448 143.902C189.536 143.99 189.656 144.04 189.781 144.04H197.13C197.255 144.039 197.373 143.988 197.46 143.9C197.506 143.858 197.541 143.807 197.565 143.75C197.59 143.693 197.601 143.632 197.6 143.57L197.64 141.74Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 196.5V136L154 106.5L190 140.5V196.5H118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.56 101.4H153.98L197.17 141.74V143.45H189.82V140.47L153.98 106.78L108.96 143.45H48.54V138.07L93.56 101.4Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.39 196.79H2.15039C40.0072 215.349 81.6093 224.998 123.771 224.998C165.932 224.998 207.534 215.349 245.39 196.79V196.79Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.15 196.8V135.74",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.82 140.47V196.8",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7305 196.8V143.23",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M233.2 202.6H14.3496C48.9046 217.507 86.1412 225.197 123.775 225.197C161.408 225.197 198.645 217.507 233.2 202.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.57 218.6H376.33C414.188 237.153 455.79 246.8 497.95 246.8C540.111 246.8 581.712 237.153 619.57 218.6V218.6Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.57 218.6H376.33C414.188 237.153 455.79 246.8 497.95 246.8C540.111 246.8 581.712 237.153 619.57 218.6V218.6Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M607.38 224.4H388.53C423.086 239.303 460.322 246.99 497.955 246.99C535.588 246.99 572.824 239.303 607.38 224.4Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 622,
    height: 330,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/Scale.135df40d3567a19700757566d9d9c50f.svg";
export { ForwardRef as ReactComponent };